import { useQuery } from "@tanstack/react-query";

import type { PublicPricing } from "@/lib/types";

/**
 * The public getPricing endpoint (same payload the landing site bakes in
 * at build time). Plain HTTPS — no auth, no App Check, cacheable.
 */
const PRICING_URL = `https://us-east1-${
  process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "wedding-uploads-9f58c"
}.cloudfunctions.net/getPricing`;

export async function fetchPublishedPricing(): Promise<PublicPricing> {
  const response = await fetch(PRICING_URL);
  if (!response.ok) {
    throw new Error(
      response.status === 404
        ? "No pricing has been published yet."
        : `Pricing request failed (${response.status}).`,
    );
  }
  return (await response.json()) as PublicPricing;
}

export function usePublishedPricing() {
  return useQuery<PublicPricing>({
    queryKey: ["publicPricing"],
    queryFn: fetchPublishedPricing,
    staleTime: 5 * 60 * 1000,
  });
}
